<template>
    <v-card class="form-container">
        <v-text-field
            v-model="newCampaign.alias"
            label="Alias"
            class="form-field"
            required
        />
        <v-text-field
            v-model="newCampaign.originator"
            label="Originator"
            :rules="[
                v => !!v || 'Field Required',
                v => (v.length >= 3) || 'Minimum 3 characters allowed',
                v => (v.length <= 11) || 'Maximum 11 characters allowed',
            ]"
            class="form-field"
            required
        />
        <label class="form-field" for="datepicker">Schedule:</label>
        <date-picker
            id="datepicker"
            v-model="newCampaign.scheduledAt"
            :disabled-date="getPastDates"
            :disabled-time="getPastTime"
            class="form-field"
            type="datetime"
        />
        <v-textarea
            v-model="newCampaign.textTemplate"
            class="form-field"
            label="SMS text template"
        />
        <v-btn
            color="primary"
            :loading="submitLoading"
            :disabled="submitLoading"
            @click="updateCampaign()"
        >
            Update
        </v-btn>
        <v-btn text @click="cancel()">
            Cancel
        </v-btn>
    </v-card>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import dateTimeUtils from '@/utils/date-time-utils'
    import 'vue2-datepicker/index.css'

    export default {
        components: { DatePicker },
        props: {
            campaign: {
                type: Object,
                required: true
            },
            submitLoading: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                newCampaign: {
                    alias: '',
                    originator: '',
                    textTemplate: ''
                }
            }
        },
        watch: {
            campaign(newVal) {
                this.newCampaign = newVal
                this.newCampaign.scheduledAt = new Date(newVal.scheduledAt)
            }
        },
        methods: {
            updateCampaign() {
                this.$emit('updateCampaign', this.newCampaign)
            },
            cancel() {
                this.$emit('cancel')
            },
            getPastDates(date) {
                return dateTimeUtils.getPastDates(date)
            },
            getPastTime(date) {
                return dateTimeUtils.getPastTime(date)
            }
        }
    }
</script>

<style scoped>

.params-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 20px;
    gap: 10px;
}

.form-container {
    padding: 1rem;
}

.form-field {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

</style>
